<bn-loading-overlay></bn-loading-overlay>

<div class="container">
  <div class="row">
    <div class="col">
      <h4>Cadastro de solicitação de renúncia de limite adicional</h4>
    </div>
    <div class="col-auto">
      <button class="btn btn-danger" type="button" (click)="cancelar()">Cancelar</button>
      <button class="btn btn-primary" type="button" (click)="abrirModalConfirmar()" [disabled]="!podeSalvar()">Salvar</button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="border rounded p-3 mb-3">
        <span style="font-style: italic;">
          Nos termos do artigo 16, § 13 e 15, e ANEXO XIV-A do Regulamento dos Programas de Garantia do PEAC,
          o Agente Financeiro informará a opção de alteração DO LIMITE ADICIONAL de garantia no formulário de solicitação.
          <b>Valor disponível do Limite Adicional no final do período não pode ser negativo.</b>
        </span>
      </div>
    </div>
  </div>

  <form [formGroup]="solicitacaoForm" class="mt-3">
    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="limiteAdicional">Limite Adicional:</label>
        <select id="limiteAdicional" class="form-select" formControlName="limiteAdicional">
          <option [ngValue]="null"></option>
          <option *ngFor="let limiteAdicional of listaLimiteAdicional" [ngValue]="limiteAdicional.ide">
            {{ limiteAdicional.limiteAdicional }} - {{ formatarMoeda(limiteAdicional.valorLimite) }}
          </option>
        </select>
      </div>
    </div>



    <div class="row">
      <div class="bn-form-group col-md-6">
        <label class="form-label">Habilitação em Faixa de Carteira PJ inferior no IF.Data:&ensp;</label>
        <div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              [value]="true"
              formControlName="habilitacaoFaixaPj"
              id="faixaPjSim">
            <label class="form-check-label" for="faixaPjSim">Sim</label>
          </div>

          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              [value]="false"
              formControlName="habilitacaoFaixaPj"
              id="faixaPjNao">
            <label class="form-check-label" for="faixaPjNao">Não</label>
          </div>
        </div>
      </div>
    </div>

    

    <div class="row">

      <div class="row align-items-center">

        <div class="bn-form-group col-auto">
          <label class="form-label">Renúncia total do Limite Adicional:&ensp;</label>

          <div>
            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                [value]="true"
                formControlName="renunciaTotal"
                id="totalSim">

              <label class="form-check-label" for="totalSim">
                Sim
              </label>
            </div>

            <div class="form-check form-check-inline">
              <input
                class="form-check-input"
                type="radio"
                [value]="false"
                formControlName="renunciaTotal"
                id="totalNao">

              <label class="form-check-label" for="totalNao">
                Não
              </label>
            </div>
          </div>
        </div>

        <ng-container *ngIf="solicitacaoForm.get('renunciaTotal').value === false">

          <div class="bn-form-group col-auto">

            <label class="form-label">Informar:</label>

            <div>
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  value="VALOR"
                  formControlName="tipoInformacao"
                  id="tipoValor">

                <label class="form-check-label" for="tipoValor">
                  Valor parcial R$
                </label>
              </div>

              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  value="PERCENTUAL"
                  formControlName="tipoInformacao"
                  id="tipoPercentual">

                <label class="form-check-label" for="tipoPercentual">
                  Percentual (xx.xx%)
                </label>
              </div>
            </div>

          </div>

          <div
            class="bn-form-group col-md-3"
            *ngIf="solicitacaoForm.get('tipoInformacao').value === 'VALOR'">

            <input
              type="text"
              class="form-control"
              bnMask="MOEDA"
              formControlName="valorParcial"
              placeholder="R$">

            <small
              class="text-danger"
              *ngIf="temErro('valorParcial', 'valorInvalido')">
              O valor não pode ser zero.
            </small>

            <small
              class="text-danger"
              *ngIf="temErro('valorParcial', 'valorMaiorQueDisponivel')">
              Valor parcial não pode ser maior que o valor disponível atual para o limite adicional {{ limiteAdicionalSelecionado?.nome }}.
            </small>

          </div>

          <div
            class="bn-form-group col-md-3"
            *ngIf="solicitacaoForm.get('tipoInformacao').value === 'PERCENTUAL'">

            <input
              type="text"
              class="form-control"
              formControlName="percentualParcial"
              placeholder="xx.xx"
              (input)="limitarPercentual($event)">

            <small
              class="text-danger"
              *ngIf="temErro('percentualParcial', 'percentualInvalido')">
              Percentual deve ser maior que zero e no máximo 100%.
            </small>

          </div>

        </ng-container>

      </div>

    </div>
  </form>
</div>

<ng-template #mensagemTermoRenuncia>

  <div class="bn-form-group row">
    <div class="col">
      <label>Termos e condições:</label>
    </div>
  </div>

  <div class="row">
    <div class="bn-form-group col-12">
      <textarea
        class="form-control"
        rows="10"
        disabled
        [(ngModel)]="textoTermoRenunciaLimiteAdicional">
      </textarea>
    </div>
  </div>

  <div class="bn-form-group row">
    <div class="col">
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="checkCiencia"
          [(ngModel)]="checkCiencia">

        <label class="form-check-label" for="checkCiencia">
          Declaro que estou ciente dos termos e condições aplicáveis
        </label>
      </div>
    </div>
  </div>

</ng-template>

<ng-template #botoesTermosRenuncia>

  <button
    class="btn btn-default"
    (click)="desistir()">
    Fechar
  </button>

  <button
    class="btn btn-primary"
    [disabled]="!checkCiencia"
    (click)="salvar()">
    Confirmar
  </button>

</ng-template>